import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["canvas_front", "canvas_side", "source", "source_side", "submitButton"];
  static values = {
    originalFrontSrc: String,
    originalSideSrc: String
  };

  connect() {
    console.log("Body comparison controller connected");
    // Store original image sources on controller initialization
    if (this.hasCanvas_frontTarget) {
      this.originalFrontSrcValue = this.canvas_frontTarget.src;
    }
    if (this.hasCanvas_sideTarget) {
      this.originalSideSrcValue = this.canvas_sideTarget.src;
    }

    // Restore any saved images from session storage
    // this.restoreImagesFromStorage();

    // Check initial state of inputs and enable/disable button accordingly
    this.updateSubmitButtonState();
  }

  disconnect() {
    // Save current state to session storage when controller disconnects
    // this.saveImagesToStorage();
  }

  show(event) {
    const reader = new FileReader();
    const source = event.currentTarget;
    let canvas;
    const controller = this;
    const imageType = source === this.sourceTarget ? 'front' : 'side';

    // Determine which canvas to update based on which input was triggered
    if (source === this.sourceTarget) {
      canvas = this.canvas_frontTarget;

      // Ensure we have stored the original src
      if (!this.hasOriginalFrontSrcValue) {
        this.originalFrontSrcValue = canvas.src;
      }
    } else if (source === this.source_sideTarget) {
      canvas = this.canvas_sideTarget;

      // Ensure we have stored the original src
      if (!this.hasOriginalSideSrcValue) {
        this.originalSideSrcValue = canvas.src;
      }
    }

    reader.onload = function() {
      const imageData = {
        type: imageType,
        dataURL: reader.result,
        timestamp: Date.now()
      };

      // Create and display the preview
      controller.createImagePreview(imageData);

      // Save to storage after processing
      // controller.saveImagesToStorage();
    };

    reader.readAsDataURL(source.files[0]);

    // Reset the file input after a delay to allow for processing
    // setTimeout(() => {
    //   source.value = "";
    // }, 1500);
  }

  createImagePreview(imageData) {
    // Determine which canvas and container to update
    let canvas, defaultContainer;
    if (imageData.type === 'front') {
      canvas = this.canvas_frontTarget;
      defaultContainer = canvas.parentElement;
    } else {
      canvas = this.canvas_sideTarget;
      defaultContainer = canvas.parentElement;
    }

    // Create image preview container with delete button
    const previewContainer = document.createElement('div');
    previewContainer.className = 'photo-comparison-upload__image';
    previewContainer.dataset.storedImage = imageData.type;

    // Create delete button
    const deleteButton = document.createElement('button');
    deleteButton.className = 'photo-comparison-upload__delete-button';
    deleteButton.innerHTML = '<svg width="18" height="20" viewBox="0 0 18 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M3.721 19.563a1.96 1.96 0 0 1-1.438-.595 1.96 1.96 0 0 1-.595-1.438V3.25H.563V1.564h5.062V.568h6.75v.995h5.063v1.688h-1.125V17.53q0 .852-.591 1.443-.591.59-1.443.59zM14.625 3.251H3.375V17.53q0 .15.097.249a.34.34 0 0 0 .25.097h10.557a.33.33 0 0 0 .238-.108.33.33 0 0 0 .108-.238zM6.08 15.626h1.687V5.5H6.08zm4.153 0h1.688V5.5h-1.688z" stroke="currentColor"/></svg>';
    deleteButton.dataset.action = 'click->body-comparison#removeImage';
    deleteButton.dataset.type = imageData.type;

    // Create the new image
    const previewImage = document.createElement('img');
    previewImage.src = imageData.dataURL;
    previewImage.dataset.bodyComparisonTarget = canvas.dataset.bodyComparisonTarget;

    // Assemble the preview container
    previewContainer.appendChild(deleteButton);
    previewContainer.appendChild(previewImage);

    // Replace the default container with our preview if it exists
    if (defaultContainer) {
      defaultContainer.parentElement.replaceChild(previewContainer, defaultContainer);
    } else {
      // If the default container doesn't exist (might be already replaced),
      // find the existing preview and replace it
      const existingPreview = this.element.querySelector(`[data-stored-image="${imageData.type}"]`);
      if (existingPreview) {
        existingPreview.parentElement.replaceChild(previewContainer, existingPreview);
      }
    }

    // Update the submit button state
    this.updateSubmitButtonState();
  }

  removeImage(event) {
    event.preventDefault();
    const type = event.currentTarget.dataset.type;

    // Get the current container (the one with the preview image)
    const previewContainer = event.currentTarget.parentElement;

    // Create the default container to replace it
    const defaultContainer = document.createElement('div');
    defaultContainer.className = 'photo-comparison-upload__default';

    // Get the original source URL from controller values
    let originalSrc;
    if (type === 'front') {
      originalSrc = this.originalFrontSrcValue;
    } else if (type === 'side') {
      originalSrc = this.originalSideSrcValue;
    }

    if (!originalSrc) {
      console.error("Original source URL not found, falling back to default");
      originalSrc = `/assets/${type === 'front' ? 'man-front-view.png' : 'man-side-view.png'}`;
    }

    // Create the default image using original URL
    const defaultImage = document.createElement('img');
    defaultImage.src = originalSrc;
    defaultImage.dataset.bodyComparisonTarget = type === 'front' ? 'canvas_front' : 'canvas_side';

    // Assemble the default container
    defaultContainer.appendChild(defaultImage);

    // Replace the preview with the default
    previewContainer.parentElement.replaceChild(defaultContainer, previewContainer);

    // Clear the file input
    if (type === 'front') {
      this.sourceTarget.value = "";
      // Remove from storage
      // this.removeImageFromStorage('front');
    } else if (type === 'side') {
      this.source_sideTarget.value = "";
      // Remove from storage
      // this.removeImageFromStorage('side');
    }

    // Update submit button state after removing an image
    this.updateSubmitButtonState();
  }

  saveImagesToStorage() {
    // Commented out to prevent clearing file inputs
    /*
    try {
      const storedImages = [];

      // Check for front image
      const frontPreview = this.element.querySelector('[data-stored-image="front"]');
      if (frontPreview) {
        const frontImg = frontPreview.querySelector('img');
        if (frontImg) {
          storedImages.push({
            type: 'front',
            dataURL: frontImg.src,
            timestamp: Date.now()
          });
        }
      }

      // Check for side image
      const sidePreview = this.element.querySelector('[data-stored-image="side"]');
      if (sidePreview) {
        const sideImg = sidePreview.querySelector('img');
        if (sideImg) {
          storedImages.push({
            type: 'side',
            dataURL: sideImg.src,
            timestamp: Date.now()
          });
        }
      }

      // Only save if we have images
      if (storedImages.length > 0) {
        sessionStorage.setItem('bodyComparisonImages', JSON.stringify(storedImages));
      } else {
        sessionStorage.removeItem('bodyComparisonImages');
      }
    } catch (error) {
      console.error('Error saving body comparison images to storage:', error);
    }
    */
  }

  restoreImagesFromStorage() {
    // Commented out to prevent issues with file inputs
    /*
    try {
      const storedImagesJson = sessionStorage.getItem('bodyComparisonImages');
      if (!storedImagesJson) return;

      const storedImages = JSON.parse(storedImagesJson);

      // Restore each image
      storedImages.forEach(imageData => {
        this.createImagePreview(imageData);
      });
    } catch (error) {
      console.error('Error restoring body comparison images from storage:', error);
    }
    */
  }

  removeImageFromStorage(type) {
    // Commented out to prevent issues with file inputs
    /*
    try {
      const storedImagesJson = sessionStorage.getItem('bodyComparisonImages');
      if (!storedImagesJson) return;

      const storedImages = JSON.parse(storedImagesJson);
      const filteredImages = storedImages.filter(img => img.type !== type);

      if (filteredImages.length > 0) {
        sessionStorage.setItem('bodyComparisonImages', JSON.stringify(filteredImages));
      } else {
        sessionStorage.removeItem('bodyComparisonImages');
      }
    } catch (error) {
      console.error('Error removing image from storage:', error);
    }
    */
  }

  clearAllStoredImages() {
    // sessionStorage.removeItem('bodyComparisonImages');
  }

  updateSubmitButtonState() {
    if (this.hasSubmitButtonTarget) {
      // Check for uploaded images in the DOM
      const hasFrontPhoto = this.element.querySelector('[data-stored-image="front"]') !== null;
      const hasSidePhoto = this.element.querySelector('[data-stored-image="side"]') !== null;

      this.submitButtonTarget.disabled = !(hasFrontPhoto || hasSidePhoto);
    }
  }
}
